"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = function _default(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Hidden data' : _ref$label,
    show = _ref.show,
    toggle = _ref.toggle,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_style["default"].link, show ? _style["default"].show : _style["default"].hide)
  }, /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
    spaceRight: true
  }), /*#__PURE__*/_react["default"].createElement("a", {
    onClick: toggle
  }, label), show && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].children
  }, children));
};
exports["default"] = _default;